import { css } from "@stubhub/broadway-foundation/css";

export const eventLink = css({
  display: "flex",
  alignItems: "center",
  columnGap: "[12px]",
  paddingBlock: "[6px]",
  paddingInline: "[12px]",
  textDecorationLine: "none",
  color: "[inherit]",
  cursor: "pointer",
  transitionProperty: "[background]",
  transitionDuration: "[0.2s]",
  transitionTimingFunction: "[ease-in-out]",
  _hover: {
    backgroundColor: "bg.surface.brand",
    boxShadow: "[0px 0px 6px 0px rgba(0, 0, 0, 0.25)]",
  },
});

export const dateCardWrapper = css({
  flexShrink: "0",
});

export const eventInfo = css({
  flexGrow: "1",
  flexShrink: "1",
  minWidth: "primitives.0",
});

export const eventTitle = css({
  fontWeight: "semibold",
  fontSize: "[15px]",
  marginBlockEnd: "primitives.50",
  color: "var(--component-text-primary)",
  lineHeight: "[1.4]",
});

export const eventDetails = css({
  fontSize: "[13px]",
  color: "var(--component-text-secondary)",
  lineHeight: "[1.5]",
});

export const buttonWrapper = css({
  flexShrink: "0",
  display: "none",
  alignItems: "center",
  minWidth: "[120px]",
  justifyContent: "flex-end",
  tablet: {
    display: "flex",
  },
  desktop: {
    display: "flex",
  },
});
